import React from "react";
import { connect } from "react-redux"
import { METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";
import { POST_SETTING_PAYMENTS, POST_SETTING_SHIPMENTS } from "../../../../config/config";

const SettingTransport = (props) => {
  const { settingPage } = props;
  const { type } = settingPage;
  return (
    <React.Fragment>
      {type === METHOD_TYPE.AUTO &&
        <div className="setting-auto-reply-wrapper setting-method">
          <div className="card">
            <div className="card-title mb16">
              <span>
                <div className="svg-next-icon card-title-icon ic-money-truck" >
                </div>
              </span>
              <span>Cài đặt phương thức thanh toán &amp; vận chuyển</span>
            </div>
            <div className="setting-method-container line-height-20">
              <div>
                <div className="icon-wrapper">
                  <div className="svg-next-icon ic-payment">
                  </div>
                </div>
                <div>
                  <div className="title">
                    <div className="text-font-weight-500">
                      Phương thức thanh toán
                    </div>
                    <div className="subtitle font-size-12">
                      Quản lý, cấu hình phương thức thanh toán
                    </div>
                  </div>
                  <div>
                    <span className="status">Thiết lập</span>
                  </div>
                  <div>
                    <a className="setting-link" href={POST_SETTING_PAYMENTS} target="_blank">
                      <span>
                        Đến trang Thiết lập
                      </span>
                      <span>
                        <div className="svg-next-icon mb2 ic_link">
                        </div>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="icon-wrapper">
                  <div className="svg-next-icon icon-shipping">
                  </div>
                </div>
                <div>
                  <div className="title">
                    <div className="text-font-weight-500">
                      Phương thức vận chuyển
                    </div>
                    <div className="subtitle font-size-12">
                      Quản lý, cấu hình phương thức vận chuyển
                    </div>
                  </div>
                  <div>
                    <span className="status">Đã thiết lập</span>
                  </div>
                  <div>
                    <a className="setting-link" href={POST_SETTING_SHIPMENTS} target="_blank">
                      <span>Đến trang Thiết lập</span>
                      <span>
                        <div className="svg-next-icon mb2 ic_link">
                        </div>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { settingPage } = state;

  return {
    settingPage
  };
};

export default connect(mapStateToProps, {})(SettingTransport);